import { ChevLeftIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

type HeaderProps = {
  showBackButton: boolean;
  disabled?: boolean;
  title?: string;
  onBack: () => void;
};

const Header = ({
  showBackButton,
  disabled = false,
  title = "Attribute Filter",
  onBack
}: HeaderProps) => {
  return (
    <div className="flex items-center gap-2 pt-3 px-3">
      {showBackButton && (
        <ChevLeftIcon
          data-testid="header-back-button"
          className={twMerge(
            "w-4 h-4 cursor-pointer",
            disabled && "text-light-gray"
          )}
          onClick={onBack}
        />
      )}
      <span
        className={twMerge(
          "text-txtHeading text-sm font-bold",
          disabled && "text-light-gray"
        )}
      >
        {title}
      </span>
    </div>
  );
};

export default Header;
